<script setup lang="ts">
import { fillFields } from "#ui/decoration/fields";
import type { DecorScreen } from "#ui/decoration/screen";
import type { DecorationFields, DecorationInsert, DecorationStates } from "#ui/decoration/types";

export interface Props {
	nodes: readonly DecorationInsert[];
	decor: DecorScreen;
	states?: DecorationStates;
	fields?: DecorationFields;
}

const props = defineProps<Props>();

const DECORATIVE = { pointerEvents: "none" } as const;

const textOf = (node: DecorationInsert) => (node.text ? fillFields(props.decor.text(node.text), props.fields) : "");
</script>

<template>
	<template v-for="node in nodes" :key="node.el">
		<div v-if="decor.visible(node.el) && textOf(node) !== null" v-bind="decor.bind(node.el, states)" :style="DECORATIVE">
			<template v-if="node.text">{{ textOf(node) }}</template>
			<DecorInserts v-else-if="node.children" :nodes="node.children" :decor="decor" :states="states" :fields="fields" />
		</div>
	</template>
</template>
